import request from "@/utils/request";
//获取购物车列表
export function GetMyCart(data={}) {
  return request({
    url: "/api/MyCart/GetMyCart",
    method: "post",
    data,
  });
}
//删除选中数据
export function DelMyCart(data={}) {
  return request({
    url: "/api/MyCart/DelMyCart",
    method: "post",
    data,
  });
}
//获取购物车数量
export function MyCartQty(data={}) {
  return request({
    url: "/api/MyCart/MyCartQty",
    method: "post",
    data,
  });
}
// 加入购物车
export function SaveMyCart(data) {
	return request({
		url: "/api/MyCart/SaveMyCart",
		method: "post",
		data
	})
}

